//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoAlertBasic from './demos/DemoAlertBasic.vue'
import DemoAlertColors from './demos/DemoAlertColors.vue'
import DemoAlertBorder from './demos/DemoAlertBorder.vue'
import DemoAlertColoredBorder from './demos/DemoAlertColoredBorder.vue'
import DemoAlertDense from './demos/DemoAlertDense.vue'
import DemoAlertDismissible from './demos/DemoAlertDismissible.vue'
import DemoAlertIcons from './demos/DemoAlertIcons.vue'
import DemoAlertVModel from './demos/DemoAlertVModel.vue'
import DemoAlertOutlined from './demos/DemoAlertOutlined.vue'
import DemoAlertText from './demos/DemoAlertText.vue'
import DemoAlertTransition from './demos/DemoAlertTransition.vue'
import DemoAlertElevation from './demos/DemoAlertElevation.vue'
import DemoAlertType from './demos/DemoAlertType.vue'

// code
import {
  alertBasic,
  alertColors,
  alertBorder,
  alertColoredBorder,
  alertDense,
  alertDismissible,
  alertIcons,
  alertVModel,
  alertOutlined,
  alertTransition,
  alertText,
  alertElevation,
  alertType,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoAlertBasic,
    DemoAlertColors,
    DemoAlertBorder,
    DemoAlertColoredBorder,
    DemoAlertDense,
    DemoAlertDismissible,
    DemoAlertIcons,
    DemoAlertVModel,
    DemoAlertOutlined,
    DemoAlertText,
    DemoAlertTransition,
    DemoAlertElevation,
    DemoAlertType,
  },

  setup() {
    return {
      codeSnippets: {
        alertBorder,
        alertColoredBorder,
        alertDense,
        alertBasic,
        alertColors,
        alertDismissible,
        alertIcons,
        alertVModel,
        alertOutlined,
        alertTransition,
        alertText,
        alertElevation,
        alertType,
      },
    }
  },
}
